import React, { useRef } from "react";

const Flex = ({ align, justify, gap, direction, mt, mb, ml, mr, style, wrap, ...rest }) => {
  const styled = useRef({
    display: "flex",
    justifyContent: justify || "flex-start",
    alignItems: align || "start",
    flexDirection: direction || "row",
    gap: gap || "0",
    marginTop: mt || "0",
    marginBottom: mb || "0",
    marginLeft: ml || "0",
    marginRight: mr || "0",
    flexWrap: wrap ? "wrap" : "nowrap",
  });

  return <div style={{ ...styled.current, ...style }} {...rest} />;
};

export default Flex;
